export type Ring = 'adopt' | 'trial' | 'assess' | 'hold'

export type Quadrant = 'languages' | 'techniques' | 'tools' | 'platforms'

export interface Technology {
  id: string
  name: string
  ring: Ring
  quadrant: Quadrant
  isNew: boolean
  description: string
  link?: string
}

export interface RadarData {
  technologies: Technology[]
}

export const RINGS: Ring[] = ['adopt', 'trial', 'assess', 'hold']

export const QUADRANTS: Quadrant[] = [
  'languages',
  'techniques',
  'tools',
  'platforms',
]

export const RING_LABELS: Record<Ring, string> = {
  adopt: 'Adopt',
  trial: 'Trial',
  assess: 'Assess',
  hold: 'Hold',
}

export const QUADRANT_LABELS: Record<Quadrant, string> = {
  languages: 'Languages & Frameworks',
  techniques: 'Techniques',
  tools: 'Tools',
  platforms: 'Platforms & Infrastructure',
}
